import React from 'react';
function CornerBottomRightRadius({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M5.8335 14.1667H9.15186C11.9215 14.1667 14.1668 11.9214 14.1668 9.15174V5.83337"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CornerBottomRightRadius;
